<template>
  <form role="form">
    <div class="row justify-content-md-center">
      <div class="col-7">
        <div class="row justify-content-md-center">
          <div class="col-12">
            <base-input
              class="mb-3"
              v-model="title"
              @input="emitUpdate()"
              placeholder="Ex: Rendimentos por Vendedor"
              label="Titulo" />
          </div>
          <div class="col-6">
            <label class="form-control-label">Tipo de Item</label>
            <multiselect
              v-model="item_type"
              @input="emitUpdate()"
              :options="typeOptions"
              placeholder="Ex: Gráfico de Barras"
              label="name"
              track-by="option"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
              :allow-empty="false"
              :preserveSearch="true"
              :key="dashboardItem.item_type" />
          </div>
          <div class="col-6">
            <label class="form-control-label">Modelo</label>
            <multiselect
              v-model="selected_class"
              @input="emitUpdate()"
              :options="classes"
              placeholder="Ex: Gráfico de Barras"
              label="translated_name"
              track-by="name"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
              :allow-empty="false"
              :preserveSearch="true"
              :key="dashboardItem.selected_class" />
          </div>
          <div class="col-12">
            <label class="form-control-label">Dados</label>
            <multiselect
              v-loading="loadingClass"
              v-model="selected_attributes"
              @input="emitUpdate()"
              :options="classData.columns || []"
              :multiple="true"
              :close-on-select="false"
              placeholder="Ex: Nome"
              label="translated_name"
              track-by="name"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
              :preserveSearch="true"
              :key="classData.name" />
          </div>
          <div class="col-6">
            <label class="form-control-label">Operador</label>
            <multiselect
              v-model="selectedAgregator"
              @input="emitUpdate()"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
              :options="agregatorOptions"
              placeholder="Ex: Média"
              label="name"
              track-by="value" />
          </div>
          <div class="col-6">
            <label class="form-control-label">Agrupar por</label>
            <el-cascader
              style="width: 100%;"
              v-model="selectedOperator"
              :key="selected_class.name"
              @change="emitUpdate()"
              :show-all-levels="false"
              :clearable="true"
              :props="operatorSelectorProps">
            </el-cascader>
          </div>
          <div class="col-12">
            <label class="form-control-label">Condições</label>
            <condition-selector
              v-for="(condition, index) in conditions"
              :initialClass="selected_class.name"
              v-model="condition.query"
              :key="selected_class.name + condition.id + index"
              @changed="addCondition(index)" />
          </div>
        </div>
      </div>
      <div class="col-5">
        <h5>Pré Visualização</h5>

        <base-alert type="warning" v-if="previewWarning">
          <span class="alert-inner--icon"><i class="fa fa-exclamation-triangle"></i></span>
          <span class="alert-inner--text">&nbsp;&nbsp;Dados insuficientes para a montagem do gráfico</span>
        </base-alert>
        <dashboard-item-card :dashboard-item="previewItem" v-loading="isLoadingPreview" :disabledActions="true" style="height: 300px" />
      </div>
    </div>
  </form>
</template>

<script>
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";


import DashboardItemCard from './DashboardItemCard';
import ConditionSelector from './components/ConditionSelector';
import { Cascader } from "element-ui";

export default {
  components: {
    Multiselect,
    DashboardItemCard,
    ConditionSelector,
    [Cascader.name]: Cascader,
  },
  props: {
    dashboardItem: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      title: '',
      item_type: {},
      selected_class: {},
      selected_attributes: [],
      selectedAgregator: {},
      selectedOperator: {},
      conditions: [{query: {}}],
      classData: {},
      classes: [],
      loadingClass: false,
      previewItem: {},
      isLoadingPreview: false,
      previewWarning: false,
      typeOptions: [
        // {name: 'Titulo',            option: 'title'}, 
        // {name: 'Texto',             option: 'text'}, 
        // {name: 'Lista',             option: 'list'}, 
        {name: 'Gráfico de Barra',  option: 'bar_chart'}, 
        {name: 'Gráfico de Linhas', option: 'line_chart'}, 
        {name: 'Gráfico de Pizza',  option: 'pie_chart'}, 
        {name: 'Gráfico de Donut',  option: 'doughnut_chart'},
      ],
      agregatorOptions: [
        {value: 'sum',     name: 'Soma'},
        {value: 'count',   name: 'Quantidade'},
        {value: 'average', name: 'Média'},
        {value: 'minimum', name: 'Valor Mínimo'},
        {value: 'maximum', name: 'Valor Máximo'},
      ],
      operatorSelectorProps: {
        lazy: true,
        parent: this,
        lazyLoad(node, resolve) {
          const klass = node.data ? node.data.class_name : this.parent.selected_class.name
          if(!klass) return
  
          this.parent.$http.secured
              .get('/api/v1/dashboards/classes/' + klass)
              .then(response => {
                const { data } = response
                var options = []
  
                data.associations.forEach(assoc => options.push({
                    value: assoc.association_name,
                    class_name: assoc.class_name,
                    label: assoc.translated_name,
                    leaf:  false
                  })
                );
  
                data.columns.forEach(col => options.push({
                    value: col.name,
                    label: col.translated_name,
                    type:  col.type,
                    leaf:  true
                  })
                );
  
                resolve(options);
              })
        },
      },
    }
  },
  methods: {
    initClasses() {
      this.$http.secured
          .get('/api/v1/dashboards/classes')
          .then(response => this.classes = response.data)
    },
    loadClassData() {
      this.loadingClass = true

      this.$http.secured
          .get('/api/v1/dashboards/classes/' + this.selected_class.name)
          .then(response => {
            this.classData = response.data
            this.loadingClass = false
          })
          .catch(() => this.loadingClass = false)
    },
    addCondition(index){
      if((this.conditions.length - 1) == index){
        this.conditions.push({query: {}})
      }
      this.removeEmptyConditions()
      this.emitUpdate()
    },
    removeEmptyConditions() {
      this.conditions = this.conditions.filter((condition, index) => index == (this.conditions.length - 1) || (condition.query.attribute && condition.query.attribute.length) || (condition.query.type && condition.query.type.value))
    },
    buildDashboardItem() {
      return {
        title: this.title,
        item_type: this.item_type && this.item_type.option,
        setup: {
          subject_class: this.selected_class.name,
          attributes: this.selected_attributes.map(att => att.name),
          agregator: this.selectedAgregator.value,
          group_by : this.selectedOperator,
          conditions: this.conditions.map(condition => {
            return {
              attribute: condition.query.attribute && condition.query.attribute,
              conditional: condition.query.conditional.value,
              type: condition.query.type && condition.query.type.value,
              value: condition.query.value,
            }
          }).filter(condition => (condition.attribute && condition.attribute.length) || condition.type)
        },
      }
    },
    emitUpdate() {
      const item = this.buildDashboardItem()
      this.$emit('update:dashboard-item', item)
      this.updatePreview(item)
    },
    updatePreview(item) {
      this.isLoadingPreview = true
      this.$http.secured
          .post(`/api/v1/dashboards/0/dashboard_items/preview`, {dashboard_item: item})
          .then(response => {
            this.previewItem = response.data
            this.isLoadingPreview = false
            this.previewWarning = false
          })
          .catch(() => {
            this.isLoadingPreview = true
            this.previewWarning = true
          })
    }
  },
  watch: {
    selected_class(newClass) {
      this.selected_attributes = []
      this.loadClassData()
    },
  },
  mounted() {
    this.initClasses()
    this.item_type = this.typeOptions.find(typeOption => typeOption.option == this.dashboardItem.item_type)
    // this.selected_class = {name: this.dashboardItem.selected_class}
  }
}
</script>

<style lang="scss" scoped>
</style>
